import React from "react";
import {logger} from "../../../../common/utils/logger/index";
import styled from "../../../styled";
import { InputBox } from "../../form/input.box";

interface Props {
  style?: any;
  onError: (value: string) => void;
}

const style = {
  base: {
    fontSmoothing: "antialiased",
  },
  invalid: {
    color: "#bd362f",
    iconColor: "#bd362f",
  },
};

const StripeInput = styled(InputBox)`
  display: flex;
  align-items: center;
  justify-content: center;
  > * {
    width: 100%;
  }
`;

export class StripeElementCard extends React.Component<Props> {

  componentDidMount() {
    try {
      if (!window.stripeCard) {
        window.stripeCard = window.stripeElements!.create("card", { style: this.props.style || style });
      }
      window.stripeCard.mount("#stripe-card-el");
      window.stripeCard.on("change", (event) => {
        if (event) {
          const error = event.error ? event.error.message : "";
          this.props.onError(error || "");
        }
      });
    }
    catch (e) {
      logger.captureException(e);
      this.props.onError("Error loading payment form, please try again");
    }
  }

  componentWillUnmount() {
    if (window.stripeCard) {
      window.stripeCard.destroy();
      window.stripeCard = undefined;
    }
  }

  render() {
    return (
      <StripeInput id="stripe-card-el"/>
    );
  }

}
